import React from "react";
import { useHistory } from "react-router-dom";
import Card from "../../../components/common/Card";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import { useState } from "react";
import { useMediaQuery } from "@material-ui/core";
import Collapse from "@mui/material/Collapse";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import AddBoxIcon from "@mui/icons-material/AddBox";
import "./hirearchy.css";
import { TreeMainService } from "../../../service/manage/h_tree/tree_main.service";
import { sweetStatusAlert } from "../../../components/common/SweetAlert";
import swal from "sweetalert";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Grid from "@mui/material/Grid";

const HirearchyCard = (props) => {
  const {
    mcode,
    group_title,
    title,
    formArray,
    mid,
    pid,
    flg_view_node,
    flg_edit_node,
    flg_delete_node,
    cnt_child_node,
    flg_add_node_child,
  } = props.cardData;

  const [isCollapsed, setIsCollapsed] = useState(
    formArray && formArray.length > 0 && props?.highlightCard === mid
  );

  const [titles, setTitles] = useState(props.titles);
  const [anchorEl, setAnchorEl] = useState(null);

  const shouldShowExpandIcons = !!title;

  const handleHeaderClick = () => {
    if (formArray && formArray.length > 0) {
      setIsCollapsed(!isCollapsed);
    }
    if (props.highlightCard !== mid) {
      props.redirect();
    }
  };

  const deleteHierarchyNode = async (child_id, parent_id) => {
    const isConfirmed = await swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete the node?",
      icon: "warning",
      buttons: ["Cancel", "Delete"],
      dangerMode: true,
    });

    if (!isConfirmed) {
      return;
    }

    props.setNodeLoading(true);
    await TreeMainService.deleteHierarchyNode(child_id).then((res) => {
      if (res.data[0].fn_tree_delete_node === 99) {
        sweetStatusAlert(
          "Failed!",
          "You can't delete a intermediate node with sibiling",
          "error"
        );
      } else if (!res.data[0].fn_tree_delete_node) {
        sweetStatusAlert("Failed!", "Unable to delete the node", "error");
      } else {
        sweetStatusAlert("Success!", "Node deleted successfully", "success");
      }
    });
    if (props.singleNodeParentParent) {
      await props.getDashboardStats(
        props.singleNodeParentParent.pid,
        props.user_id,
        props.user_table_id,
        props.singleNodeParentParent.mid
      );
    } else {
      await props.getDashboardStats(
        parent_id,
        props.user_id,
        props.user_table_id
      );
    }
  };

  const getGroupTitleById = (group_id) => {
    const foundTitle = titles?.find((title) => title.group_id === group_id);
    return foundTitle ? foundTitle.group_title : null;
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    if (props.highlightCard !== mid) {
      props.redirect();
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="hirearchy-card">
      <Card>
        <div
          className={`row card-custom hcard-header ${
            props.highlightCard === mid ? "selected-card" : ""
          } ${!!cnt_child_node || !!flg_add_node_child ? "hoverable" : ""}`}
        >
          {!!flg_view_node && (
            <div
              onClick={() => {
                props.redirect();
              }}
              className="col-md-10 col-10 px-0"
              style={{
                cursor:
                  !!cnt_child_node || !!flg_add_node_child
                    ? "pointer"
                    : "default",
              }}
            >
              <div className="row hcard-title">
                <div className="col-md-12 col-11 px-0">
                  <p
                    style={{
                      color:
                        props.highlightCard === mid ? "#FFFFFF" : "#382f83",
                    }}
                  >
                    {title}
                  </p>
                </div>
                <div className="col-md-12 col-11 px-0 hcard-subtitle">
                  <p
                    style={{
                      color:
                        props.highlightCard === mid ? "#FFFFFF" : "#382f83",
                    }}
                  >
                    {mcode} / {getGroupTitleById(parseInt(group_title))}
                  </p>
                </div>
              </div>
            </div>
          )}

          <div
            onClick={handleHeaderClick}
            className="col-md-1 col-1 px-0 d-flex align-items-center justify-content-end expand-icons"
          >
            {shouldShowExpandIcons &&
              !!cnt_child_node &&
              (isCollapsed ? (
                <ExpandLessIcon
                  sx={{ fontSize: 20 }}
                  style={{ color: "black", cursor: "pointer" }}
                />
              ) : (
                <ExpandMoreIcon
                  sx={{ fontSize: 20 }}
                  style={{ color: "black", cursor: "pointer" }}
                />
              ))}
          </div>

          {(!!flg_edit_node || !!flg_delete_node || !!flg_add_node_child) && (
            <div className="col-md-1 col-1 px-0 d-flex align-items-center justify-content-center expand-icons">
              <IconButton
                aria-label="more"
                id="long-button"
                aria-haspopup="true"
                onClick={handleClick}
                className="more-icon"
              >
                <MoreVertIcon sx={{ fontSize: 14 }} />
              </IconButton>
              <Menu
                id="long-menu"
                MenuListProps={{
                  "aria-labelledby": "long-button",
                }}
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                {!!flg_add_node_child && (
                  <MenuItem
                    onClick={() => {
                      props.toggleInsertModal(false, mid, true);
                      handleClose();
                    }}
                  >
                    <div className="col-md-4 d-flex justify-content-center action-icons-delete">
                      <AddBoxIcon
                        sx={{ fontSize: 14, color: "#A2A5B5" }}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                    <p>Add</p>
                  </MenuItem>
                )}
                {!!flg_edit_node && (
                  <MenuItem
                    onClick={() => {
                      props.toggleUpdateModal(props.cardData);
                      handleClose();
                    }}
                  >
                    <div className="col-md-4 d-flex justify-content-center action-icons-edit">
                      <BorderColorOutlinedIcon
                        sx={{ fontSize: 14, color: "#A2A5B5" }}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                    <p>Edit</p>
                  </MenuItem>
                )}
                {!!flg_delete_node && (
                  <MenuItem
                    onClick={() => {
                      deleteHierarchyNode(mid, pid);
                      handleClose();
                    }}
                  >
                    <div className="col-md-4 d-flex justify-content-center action-icons-delete">
                      <DeleteForeverIcon
                        sx={{ fontSize: 16, color: "#A2A5B5" }}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                    <p>Delete</p>
                  </MenuItem>
                )}
              </Menu>
            </div>
          )}
        </div>

        <Collapse in={isCollapsed}>
          <div className="">
            <div className="form-container d-flex justify-content-start text-left">
              <List>
                {formArray?.map((form, index) => (
                  <ListItem
                    style={{
                      paddingTop: "3px",
                      paddingBottom: "8px",
                      paddingLeft: "10px",
                      paddingRight: "10px",
                    }}
                    key={index}
                  >
                    <button
                      className="form-list"
                      onClick={() => {
                        props.redirectParent(undefined, form);
                      }}
                    >
                      <div
                        className="row d-flex align-items-center"
                        style={{ display: "flex", flexWrap: "nowrap" }}
                      >
                        <div
                          className="column"
                          style={{
                            display: "inline-block",
                            marginRight: "8px",
                          }}
                        >
                          &#8226; &nbsp;
                        </div>
                        <div
                          className="column"
                          style={{ display: "inline-block" }}
                        >
                          {form.title}
                        </div>
                      </div>
                    </button>
                  </ListItem>
                ))}
              </List>
            </div>
          </div>
        </Collapse>
      </Card>
    </div>
  );
};

export default HirearchyCard;
